module.exports = __webpack_public_path__ + "img/Primordial-3-mobile.4be569f0.png";